import request from '@/config/axios'
export const getCategoryList = () => request.get({ url: '/short-video/category/list' })
export const createCategory = (data: any) =>
  request.post({ url: '/short-video/category/create', data })
export const updateCategory = (data: any) =>
  request.put({ url: '/short-video/category/update', data })
export const deleteCategory = (id: number) =>
  request.delete({ url: '/short-video/category/delete', params: { id } })
